import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mountain } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  const inputCls =
    "w-full border border-paper/20 bg-paper/5 px-4 py-3.5 text-lg text-paper outline-none transition-[border-color,box-shadow] duration-300 placeholder:text-paper/30 focus:border-terra focus:ring-2 focus:ring-terra/25";

  return (
    <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-deep px-5">
      <form onSubmit={submit} className="w-full max-w-sm border border-paper/15 p-9">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terra text-paper">
          <Mountain size={20} />
        </span>
        <h1 className="mt-6 font-serif text-3xl tracking-tight text-paper">Guide's door</h1>
        <p className="mt-2 text-base text-paper/50">Salt &amp; Stone admin — Vasilis only.</p>

        <label className="mt-8 block">
          <span className="mb-2 block text-sm uppercase tracking-[0.2em] text-paper/50">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email-input" className={inputCls} autoComplete="email" />
        </label>
        <label className="mt-5 block">
          <span className="mb-2 block text-sm uppercase tracking-[0.2em] text-paper/50">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input" className={inputCls} autoComplete="current-password" />
        </label>

        {error && (
          <p data-testid="admin-login-error" className="mt-4 border border-red-400/40 bg-red-500/10 px-4 py-3 text-base text-red-300">
            {error}
          </p>
        )}

        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-7 w-full rounded-full bg-terra py-4 text-base uppercase tracking-[0.18em] text-paper transition-[background-color,opacity] duration-300 hover:bg-terra-dark disabled:opacity-50">
          {loading ? "Opening…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
